<!-- To be uncommented whenever registration is closed -->
<!-- <div class="ClosedRegistrationContainer">
    <div class="ClosedRegistration">Registration is officially closed.</div>
    <div class="ClosedRegistration">Please put your information into our waiting list on our website if you would still like to come.</div>
</div>
<div class="LinkContainer h4">
    <div class="row">
        <div class="md-form-field-container">
        <a class="NavButton" href="https://www.facebook.com/your-org-facebook/">
            Check out our Facebook
        </a>
        </div>
        <div class="md-form-field-container">
        <a class="NavButton" href="Your org website link with closed registration page.">
            Return to {Your org name} Website
        </a>
        </div>
    </div>
    </div> -->

<div class="form-title-container">
    <div class="title">
        <p>Registration Info</p>
    </div>

    <!-- Currently can only register one person at a time -->
    <!-- <div class="total-info">
        Total Registers:
        <span *ngIf="people.length != undefined">{{people.length}}</span>
        <span *ngIf="people.length == undefined">0</span>
    </div> -->
</div>

<!-- Attendee Forms -->
<form [formGroup]="attendeeForm" #checkout="ngForm" class="form-container">

    <!-- Button to be removed when done testing -->
    <!-- <button (click)="fullUpdate()">Full update button</button> -->

    <div class="form-group">
        <!-- Personal Info -->
        <h3>Personal Information</h3>

        <div class="form-row">
            <div class="md-form-field-container">
                <label class="control-label">First Name</label>
                <input class="form-control" type="text" formControlName="first_name" placeholder="Enter Your First Name"
                    (change)="addAttendee()" required>
                <div [hidden]="first_name.valid || first_name.untouched" class="alert alert-danger">
                    First Name is required
                </div>
            </div>
            <div class="md-form-field-container">
                <label class="control-label">Last Name</label>
                <input class="form-control" type="text" formControlName="last_name" placeholder="Enter Your Last Name"
                    (change)="addAttendee()" required>
                <div [hidden]="last_name.valid || last_name.untouched" class="alert alert-danger">
                    Last Name is required
                </div>

            </div>
        </div>
        <div class="form-row">
            <div class="md-form-field-container">
                <label class="control-label" for="email">Email</label>
                <input class="form-control" type="email" placeholder="Enter Your Email if applicable" name="email"
                    formControlName="email" (change)="addAttendee()" required>
                <div [hidden]="email.valid || email.untouched" class="alert alert-danger">
                    Email is required
                </div>
            </div>
            <div class="md-form-field-container">
                <label class="control-label" for="personal_phone_number">Phone Number</label>
                <input class="form-control" appPhoneMask type="text" placeholder="Enter Phone Number"
                    name="personal_phone_number" formControlName="personal_phone_number" (change)="addAttendee()">
            </div>

           
            <div class="sm-form-field-container">
                <label class="control-label">Gender</label>
                <select class="form-control" formControlName="gender" (change)="addAttendee()" required>
                    <option disabled selected value> --Select-- </option>
                    <option *ngFor="let gender of genders" [value]="gender">{{gender}}</option>
                </select>
                <div [hidden]="gender.valid || gender.untouched" class="alert alert-danger">
                    Gender is required
                </div>
            </div>
            <div class="sm-form-field-container">
                <label class="control-label">Age</label>
                <input class="form-control" type="number" formControlName="age" placeholder="Age"
                    (change)="addAttendee()" required>
                <div [hidden]="age.valid || age.untouched" class="alert alert-danger">
                    Age is required
                </div>
            </div>

        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label">
                    Do you want to add a T-Shirt? (Registration is $150 without a T-Shirt and $175 with a T-Shirt.)
                    <span class="description">
                        Please make sure you select your shirt size above if you choose to add a T-shirt.
                    </span>
                </label>
                <select class="form-control"
                        formControlName="add_shirt"
                        (change)="addAttendee()">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                </select>
            </div>
        </div>
         <div class="sm-form-field-container" *ngIf="add_shirt.value">
                <label class="control-label">T-Shirt Size</label>
                <select class="form-control"
                        formControlName="t_shirt"
                        (change)="addAttendee()">
                    <option disabled selected value> --Select-- </option>
                    <option *ngFor="let size of sizes" [value]="size">{{size}}</option>
                </select>
            </div>
        <!--    Church Contact-->
        <h3 style="margin-top:20px;">Church Contact</h3>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="your_churches">Your Church</label>
                <select class="form-control" formControlName="your_churches" (change)="addAttendee()" required>
                    <option *ngFor="let your_churches of church_list" [value]="your_churches">{{your_churches}}</option>
                </select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="your_church">Your Church: If you chose "Other"</label>
                <input class="form-control non-required" type="text" placeholder="Enter Your Church Name"
                    name="your_church" formControlName="your_church" (change)="addAttendee()">
            </div>
        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="your_church_point_of_contact_name">Your Church Point of Contact
                    Name</label>
                <input class="form-control non-required" type="text"
                    placeholder="Enter Your Church Point of Contact Name" name="your_church_point_of_contact_name"
                    formControlName="your_church_point_of_contact_name" (change)="addAttendee()">
            </div>
        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="your_church_point_of_contact_number">Your Church Point of Contact
                    Number</label>
                <input class="form-control non-required" appPhoneMask type="text"
                    placeholder="Enter Your Church Point of Contact Phone Number"
                    name="your_church_point_of_contact_number" formControlName="your_church_point_of_contact_number"
                    (change)="addAttendee()">
            </div>
        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="state">State</label>
                <select class="form-control non-required" formControlName="state" (change)="addAttendee()">
                    <option disabled selected value> --Select-- </option>
                    <option *ngFor="let state of states" [value]="state">{{state}}</option>
                </select>
            </div>
        </div>

        <!-- Emergency Contact -->
        <h3 style="margin-top:20px;">Emergency Contact</h3>
        <div class="form-row">
            <div class="md-form-field-container">
                <label class="control-label" for="">First Name</label>
                <input class="form-control" type="text" placeholder="Enter First Name"
                    name="emergency_contact_first_name" formControlName="emergency_contact_first_name"
                    (change)="addAttendee()" required>
                <div [hidden]="emergency_contact_first_name.valid || emergency_contact_first_name.untouched"
                    class="alert alert-danger">Emergency contact first name is required</div>
            </div>
            <div class="md-form-field-container">
                <label class="control-label" for="emergency_contact_last_name">Last Name</label>
                <input class="form-control" type="text" placeholder="Enter Last Name" name="emergency_contact_last_name"
                    formControlName="emergency_contact_last_name" (change)="addAttendee()" required>
                <div [hidden]="emergency_contact_last_name.valid || emergency_contact_last_name.untouched"
                    class="alert alert-danger">Emergency contact last name is required</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="emergency_email">Email</label>
                <input class="form-control" type="text" placeholder="Enter Contact's Email" name="emergency_email"
                    formControlName="emergency_email" (change)="addAttendee()" required>
                <div [hidden]="emergency_email.valid || emergency_email.untouched" class="alert alert-danger">Emergency
                    contact phone number is required</div>
            </div>
        </div>

        <div class="form-row">
            <div class="md-form-field-container">
                <label class="control-label" for="emergency_contact_phone_number">Phone Number</label>
                <input class="form-control" appPhoneMask type="text" placeholder="Enter Phone Number"
                    name="emergency_contact_phone_number" formControlName="emergency_contact_phone_number"
                    (change)="addAttendee()" required>
                <div [hidden]="emergency_contact_phone_number.valid || emergency_contact_phone_number.untouched"
                    class="alert alert-danger">Emergency contact phone number is required</div>
            </div>
            <div class="md-form-field-container">
                <label class="control-label" for="emergency_contact_relationship">Relationship</label>
                <input class="form-control" type="text" placeholder="Relationship" name="emergency_contact_relationship"
                    formControlName="emergency_contact_relationship" (change)="addAttendee()" required>
                <div [hidden]="emergency_contact_relationship.valid || emergency_contact_relationship.untouched"
                    class="alert alert-danger">Emergency contact relationship is required</div>
            </div>
        </div>

        <!-- Medical Concern -->
        <h3 style="margin-top:20px;"> Medical Concerns </h3>
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="food_allergies"> Do you have any medical issues?</label>


                <!-- added a hide or show button-->
                <button class="extra-info-btn" style="margin-Left: 10px; border-radius: 5px;"
                    (click)="toggleVisibility('myElement', true)">Yes</button>
                <button class="extra-info-btn" style="margin-left: 10px; border-radius: 5px;"
                    (click)="toggleVisibility('myElement', false)">No</button>
                <div class="description">
                    Please inform us of any allergies to medication, food, animals, etc?
                </div>
                <!-- this block will show when button is clicked-->
                <div id="myElement" style="display: none">

                    <textarea class="form-control non-required" type="text" formControlName="food_allergies" rows="5"
                        (change)="addAttendee()"></textarea>
                </div>
            </div>
        </div>

        <!--T-shirt-->
        
        <!-- CVCF Background -->
        <h3 style="margin-top:20px;">CVCF Information</h3>
        <label class="control-label" for="comments_concerns">Days attending CVCF?</label>
        <div class="description">
            Please select which days you planning to join us at CVCF?
        </div>
        <div class="form-row">
            <div class="form-field-container radio">
                <div *ngFor="let day of attendeeForm.get('days')['controls']; let i=index">
                    <div>
                        <input class="icheckbox_flat" id="flat-checkbox-2" type="checkbox" [formControl]="day"
                            (change)="addAttendee()" />
                        <label>{{days_chosen[i].name}}</label>
                    </div>
                </div>
            </div>
        </div>

    
        <div class="form-row">
            <div class="form-field-container">
                <label class="control-label" for="comments_concerns"> Any additional questions or concerns?</label>
                <!-- added a hide or show button-->
                <button class="extra-info-btn" style="margin-Left: 10px; border-radius: 5px;"
                    (click)="toggleVisibility('myElement2', true)">Yes</button>
                <button class="extra-info-btn" style="margin-left: 10px; border-radius: 5px;"
                    (click)="toggleVisibility('myElement2', false)">No</button>
                <div class="description">
                    Please inform us of anything else you want us to know?
                </div>
                <!-- this block will show when button is clicked-->
                <div id="myElement2" style="display: none">

                    <textarea class="form-control non-required" type="text" formControlName="comments_concerns" rows="5"
                        (change)="addAttendee()"></textarea>
                </div>
            </div>
        </div>
        <hr>

        <!-- Number of attendees
        <div class="form-field-container">
            <ul class="pagination">
                <li class="user-entry" *ngFor="let person of people; let i = index"
                    [ngClass]="{'active': currentAttendee === person}" (click)="loadAttendee(person, i);">
                    <button type="button" *ngIf="people.length > 1" class="delete-button"
                        (click)="deleteAttendee(i)">-</button>
                    <div class="pagination-button">{{i+1}}</div>
                </li>
                <li>
                    <a id="add-entry-box" (click)="createNewAttendee()">
                        <i class="fa fa-plus fa-2x add-entry"></i>
                    </a>
                </li>
            </ul>

        </div> -->

        <!-- Warning message -->
        <div class="form-field-container warning-text">
            <div [hidden]="first_name.valid">First Name is required</div>
            <div [hidden]="last_name.valid">Last Name is required</div>
            <!-- <div [hidden]="t_shirt.valid">T-shirt size is required</div> -->
            <div [hidden]="gender.valid">Gender is required</div>
            <div [hidden]="age.valid">Age is required</div>

            <div [hidden]="emergency_contact_first_name.valid">Emergency contact first name is required</div>
            <div [hidden]="emergency_contact_last_name.valid">Emergency contact last name is required</div>
            <div [hidden]="emergency_email.valid">Emergency email is required</div>
            <div [hidden]="emergency_contact_phone_number.valid">Emergency contact phone number is required</div>
            <div [hidden]="emergency_contact_relationship.valid">Emergency contact relationship is required</div>

            <div [hidden]="your_churches.valid">Church Selection (or N/A) is required</div>
        </div>
    </div>
</form>



<!-- spacing -->
<div style="height: 30px;"></div>

<!-- next button -->
<div class="nav-buttons">
    <button class="nav-button next-button" [disabled]="!checkout.form.valid || (add_shirt.value && !t_shirt.value)"
        routerLink="/review">
        Next
    </button>
</div>

<!-- spacing -->
<div style="height: 80px;"></div>